<div class="wrapper">
    <h1 i18n="@@notFoundTitle">Page not found</h1>
    <p i18n="@@notFoundMessage">Sorry, the page you are looking for does not exist.</p>
    <!-- add border radius class -->
    <a class="button primary mt-4" routerLink="/" i18n="@@notFoundHomeLink">Go back to the home page</a>

</div>
